import { connect } from 'react-redux'
import { openDrawer } from '@opallabs/kuiper'
import { hasUnseenNotificationSelector } from './selectors'
import UserMenu from '.'

const mapStateToProps = (state) => ({
  hasUnseenNotification: hasUnseenNotificationSelector(state),
})

const mapDispatchToProps = () => ({
  onClickAvatar: () => {
    openDrawer('darwin')
  },
})

const ConnectedUserMenu = connect(mapStateToProps, mapDispatchToProps)(UserMenu)

export default ConnectedUserMenu
